import { render, staticRenderFns } from "./hierarchyDDL.vue?vue&type=template&id=0c235213&scoped=true&"
import script from "./hierarchyDDL.vue?vue&type=script&lang=js&"
export * from "./hierarchyDDL.vue?vue&type=script&lang=js&"
import style0 from "./hierarchyDDL.vue?vue&type=style&index=0&id=0c235213&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c235213",
  null
  
)

export default component.exports